<template>
  <div class="container-fluid">
    <div>
      <div class="card">
        <div id="topo" class="card-header">
          <div class="row">
            <div class="col col-xs-2">
              <h4 class="panel-title">
                <span class="title">{{
                  notaTomador ? 'Consulta e gerenciamento das Notas Fiscais de Serviço Tomadas.' :
                    'Consulta e gerenciamento dos Documentos Auxiliares de Prestação de Serviço (DAPS) emitidos.'
                }}</span>
                <br />
                <span class="navigation">{{ notaTomador ? 'Nota Tomador > Consulta' : 'DAPS > Consulta' }}</span>
              </h4>
            </div>
          </div>
        </div>
        <div class="card-body">
          <error-list :erros="erros" />
          <consulta-declaracoes-nota-fiscal />
          <cancelar-nota-fiscal />
          <enviar-email-daps />
          <exportar-nfse-maior-periodo origem="DAPS" />

          <div class="row">
            <div class="col-md-3 col-lg-2 mb-3">
              <span class="p-fluid">
                <Dropdown id="tipoEmissao" name="tipoEmissao" @change="pesquisar()" v-model="selectedTipoDaps"
                  :options="tiposDaps" optionLabel="name" placeholder="Tipo Emissão" @keyup.enter="pesquisar" />
              </span>
            </div>
            <div class="col-md-3 col-lg-1 mb-3">
              <span class="p-fluid">
                <InputText type="text" id="filtroNumero" v-model="filtroNumero" placeholder="Número" autocomplete="off"
                  @keyup.enter="pesquisar" />
              </span>
            </div>
            <div class="col-md-3 col-lg-2 mb-3">
              <span class="p-fluid">
                <CustomCalendar id="dataIni" v-model="dataFatoGeradorIni" :showIcon="true" dateFormat="dd/mm/yy"
                  placeholder="Data Inicial" @keyup.enter="pesquisar" />
              </span>
            </div>
            <div class="col-md-3 col-lg-2 mb-3">
              <span class="p-fluid">
                <CustomCalendar id="dataFim" v-model="dataFatoGeradorFim" :showIcon="true" dateFormat="dd/mm/yy"
                  placeholder="Data Final" @keyup.enter="pesquisar" />
              </span>
            </div>
            <div class="col-md-12 col-lg-3 mb-3">
              <!-- <span class="p-fluid">
                <AutoComplete
                    id="tomador"
                    v-model="selectedPessoa"
                    :dropdown="true"
                    :suggestions="filteredPessoas"
                    @complete="searchPessoa($event)"
                    field="detail"
                    :placeholder="nomeFiltro"
                    @keyup.enter="pesquisar"
                  />
                </span>-->
              <span class="p-fluid">
                <InputText type="text" id="filtro" v-model="filtro" :placeholder="nomeFiltro" autocomplete="off" />
              </span>
            </div>
            <div class="col-md-3 col-lg-2 mb-2">
              <span class="p-fluid">
                <Dropdown id="situacao" v-model="filtroSituacao" :options="filtroSituacoes" optionLabel="name"
                  placeholder="Selecione uma Situação" />
              </span>
            </div>
            <div class="col-md-6 mb-2 d-flex" v-if="exibirFiltroIntermediario">
              <Checkbox id="binary" v-model="filtroPesquisarIntermediario" :binary="true" />
              <label class="ml-2" for="binary">Pesquisar como Intermediário?</label>
            </div>
          </div>
          <div class="mb-2">
            <Button @click="pesquisar()" label="Pesquisar" type="button" class="p-button-primary mr-2"
              icon="pi pi-search" :disabled="loading" />
            <!--
            <SplitButton
              @click="imprimirConsultaDAPS()"
              label="Imprimir"
              icon="pi pi-print"
              :model="menuImpressao"
              title="Imprimir"
              :disabled="loading"
            />
            -->
            <Button class="btn btn-primary mr-2" type="button" id="dropdownMenuButton" icon="pi pi-angle-down"
              label="Imprimir" data-toggle="dropdown" title="Imprimir" aria-haspopup="true" aria-expanded="false"
              :disabled="loading"></Button>
            <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
              <button class="dropdown-item" type="button" :disabled="loading" @click="imprimirPdf()">
                <span class="pi pi-print mr-2"></span>{{ notaTomador ? 'Relação de Notas Tomador' : 'Relação de DAPS' }}
              </button>
              <button class="dropdown-item" type="button" :disabled="loading" @click="imprimirRelacaoNfse()">
                <span class="pi pi-print mr-2"></span>Relação de Notas Fiscais
              </button>
              <button class="dropdown-item" type="button" :disabled="loading" @click="imprimirLivroFiscalTomados()">
                <span class="pi pi-print mr-2"></span>Livro Fiscal Serviços Tomados
              </button>
            </div>
            <Button @click="downloadListagemXml()" label="Exportar XML Notas Fiscais" type="button"
              class="p-button-primary mr-2" icon="pi pi-download" :disabled="loading" />
            <Button @click="downloadListagemXml(true)" label="Exportar XML (Nota Nacional)" type="button"
              class="p-button-primary mr-2" icon="pi pi-download" :disabled="loading" />
            <Button @click="exportarMaiorPeriodo()" label="Exportar Notas Fiscais Assíncronos" type="button" 
              class="p-button-primary mr-2" icon="pi pi-download" :disabled="loading" />
          </div>

          <hr />

          <div class="row pr-3 pl-3">
            <DataTable :value="dapsList" :paginator="true" :rows="10" :autoLayout="true" ref="dt">
            <template #empty>
              Nenhum resultado encontrado.
              </template>
              <Column headerStyle="width: 4.2em">
                <template #body="slotProps">
                  <div class="dropdown">
                    <Button class="btn btn-primary" type="button" icon="pi pi-angle-down" id="dropdownMenuButton"
                      title="Opções" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"></Button>
                    <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                      <button v-if="exibirCampoNfsa(slotProps.data.tipo, slotProps.data.situacao) && slotProps.data.transmitidoNacional === 'I'" 
                        class="dropdown-item" type="button" :disabled="loading"
                        @click="visualizarDanfse(slotProps.data.id)"><span
                          class="pi pi-download mr-2"></span>DANFSE</button>
                      <button v-if="exibirCampoNfsa(slotProps.data.tipo, slotProps.data.situacao) && slotProps.data.transmitidoNacional !== 'I'" 
                        class="dropdown-item" type="button" :disabled="loading"
                        @click="visualizar(slotProps.data.tipo, slotProps.data.id)"><span
                          class="pi pi-search mr-2"></span>Visualizar</button>
                      <button v-if="exibirCampoNfsa(slotProps.data.tipo, slotProps.data.situacao) && slotProps.data.transmitidoNacional !== 'I'" 
                        class="dropdown-item" type="button" :disabled="loading"
                        @click="download(slotProps.data.tipo, slotProps.data.id)"><span
                          class="pi pi-download mr-2"></span>Download</button>
                      <div class="dropdown-divider" />
                      <button class="dropdown-item" type="button"
                        v-if="slotProps.data.situacao != 'Cancelada' && slotProps.data.tipo === 'D'"
                        :disabled="loading || inativo" @click="cancelarDaps(slotProps.data.id)"><span
                          class="pi pi-times mr-2"></span>Cancelar</button>
                      <button class="dropdown-item" type="button" v-if="slotProps.data.tipo === 'N'" :disabled="loading"
                        @click="downloadXml(slotProps.data.id)">
                        <span class="pi pi-download mr-2"></span>Exportar XML
                      </button>
                      <button class="dropdown-item" type="button" :disabled="loading" v-if="slotProps.data.tipo === 'D'"
                        @click="visualizarAnexo(slotProps.data.id)">
                        <span class="pi pi-envelope mr-2"></span>Anexo
                      </button>
                      <button class="dropdown-item" type="button" :disabled="loading ||
                        slotProps.data.situacao == 'Cancelada' ||
                        slotProps.data.situacao == 'Substituída'
                        " v-show="slotProps.data.tipo === 'D'" @click="enviarEmail(slotProps.data.id)">
                        <span class="pi pi-envelope mr-2"></span>Enviar por
                        E-mail
                      </button>
                      <div class="dropdown-divider" />
                      <button class="dropdown-item" type="button" :disabled="loading" v-show="exibirConsultaDeclaracao"
                        @click="consultaDeclaracoesDaps(slotProps.data.tipo, slotProps.data.id)">
                        <span class="pi pi-file-o mr-2"></span>Consulta de Declarações
                      </button>
                      <button class="dropdown-item" type="button" :disabled="loading"
                        v-if="slotProps.data.tipo === 'D' && slotProps.data.motivoRecusaDaps != null && slotProps.data.motivoRecusaDaps"
                        v-show="exibirConsultaDeclaracao" @click="consultaMotivoRecusa(slotProps.data.id)">
                        <span class="pi pi-file-o mr-2"></span>Visualizar Motivo de Recusa
                      </button>
                      <div class="dropdown-divider" />
                      <button class="dropdown-item" type="button" :disabled="loading"
                        v-if="slotProps.data.tipo === 'D' && slotProps.data.motivoRecusaDaps"
                        @click="detailDaps(slotProps.data.id)">
                        <span class="pi pi-plus mr-2"></span>Refazer Daps
                      </button>
                      <button class="dropdown-item" type="button"
                        v-if="slotProps.data.tipo === 'N' && slotProps.data.deferimentoAceite === 'S' && exibirAnaliseCancelamento"
                        :disabled="loading"
                        @click="exibirTelaDeferimento(slotProps.data.id, slotProps.data.documentoTomador)">
                        <span class="pi pi-check mr-2"></span>Análise Cancelamento
                      </button>
                    </div>
                  </div>
                </template>
              </Column>
              <Column field="tipoDescricao" header="Tipo" bodyStyle="text-align:center" headerStyle="width: 10em"
                v-if="!notaTomador">
              </Column>
              <Column field="tipoDescricaoNotaTomador" header="Tipo" bodyStyle="text-align:center" v-if="notaTomador">
              </Column>
              <Column field="numeroNota" header="Número" bodyStyle="text-align:right"></Column>
              <Column field="competenciaFormatada" header="Competência" bodyStyle="text-align:center"></Column>
              <Column field="dataGeracaoFormatada" header="Geração" bodyStyle="text-align:center"></Column>
              <Column headerStyle="min-width: 10em" field="valorFormatado" header="Valor" bodyStyle="text-align:right">
              </Column>
              <Column headerStyle="min-width: 15em" field="dadosPrestador" header="Prestador"
                v-if="this.selectedTipoDaps.key != 'P'">
              </Column>
              <Column headerStyle="min-width: 15em" field="dadosTomador" header="Tomador"
                v-if="this.selectedTipoDaps.key != 'T' && this.selectedTipoDaps.key != 'E'"></Column>
              <Column field="tipoRecolhimentoFormatado" header="Retido" headerStyle="min-width: 10em" bodyStyle="text-align:center"></Column>
              <Column field="situacao" header="Situação" bodyStyle="text-align:center"></Column>
              <template #footer>
                <div style="text-align: right">
                  <Button icon="pi pi-external-link" label="Exportar para XLS" @click="imprimirExcel()" />
                </div>
              </template>
            </DataTable>
          </div>
        </div>
      </div>
    </div>
    <Dialog header="Motivo de Recusa" :visible.sync="showMotivoRecusa" :modal="true" :closable="false">
      <h1 class="titulo-header">
        Motivo de Recusa
        <Button id="icon-close-modals" icon="pi pi-times" class="p-button-rounded p-button-text"
          @click="showMotivoRecusa = false" />
      </h1><br />
      <div class="container scrolable-dialog">
        <div id="topo" class="row">
          <DataTable :value="motivoRecusaList" :paginator="true" :rows="5" class="p-datatable-responsive"
            :autoLayout="true">
            <Column field="motivoRecusaDaps" header="Motivo Recusa"></Column>
          </DataTable>
        </div>
      </div>

      <hr />

      <div class="container">
        <div class="row">
          <div>
            <Button @click="ocultarDialogRecusaDaps()" type="button" label="Fechar"
              class="p-button-primary mr-2 p-button-danger" icon="pi pi-times" />
          </div>
        </div>
      </div>
    </Dialog>
    <Dialog header="Anexo" :visible.sync="displayAnexos" :style="{ width: '35vw' }" :modal="true">
      <h1 class="titulo-header">
        Anexo
        <Button id="icon-close-modals" icon="pi pi-times" class="p-button-rounded p-button-text"
          @click="displayAnexos = false" />
      </h1><br />
      <DataTable :value="anexosDaps" :paginator="true" :rows="10" :autoLayout="true" style="min-width: 100%">
        <template #empty>Nenhum anexo encontrado.</template>
        <Column headerStyle="width: 2.5em" header bodyStyle="text-align: center">
          <template #body="slotProps">
            <Button type="button" title="Download" class="p-button-primary mr-2" icon="pi pi-download"
              style="margin-right: 0.5em" @click="
                downloadArquivo(
                  slotProps.data.id,
                  slotProps.data.tipoArquivo,
                  slotProps.data.nomeArquivo,
                )
                " :disabled="loading"></Button>
          </template>
        </Column>
        <Column field="nomeArquivo" header="Arquivo" bodyStyle="text-align:right"></Column>
      </DataTable>
      <hr />
      <div class="container">
        <div class="row">
          <div>
            <Button label="Fechar" icon="pi pi-times" @click="displayAnexos = false" class="p-button-danger" />
          </div>
        </div>
      </div>
    </Dialog>
    <Dialog header="Analise Cancelamento Nota Fiscal" :visible.sync="showDeferimento" :style="{ width: '90vw' }"
      :contentStyle="{ overflow: 'visible' }" :modal="true">
      <h1 class="titulo-header">
        Análise Cancelamento Nota Fiscal
        <Button id="icon-close-modals" icon="pi pi-times" class="p-button-rounded p-button-text"
          @click="showDeferimento = false" />
      </h1><br />
      <div class="row">
        <div class="col-md-12 mb-2 mensagem-cancelamento">
          <p>Foi solicitada análise para cancelamento desta nota fiscal, faça abaixo o registro de deferimento ou não do cancelamento!</p>
          <p>Após o registro do deferimento, a nota fiscal passará também pela análise do Fiscal para efetivação do cancelamento.</p>
        </div>
      </div>
      <DataTable :value="deferimentos" :paginator="true" :rows="4" :autoLayout="true" style="min-width: 100%">
        <Column>
          <template #body="slotProps">
            <div v-if="slotProps.data.statusTomador != 'N' && slotProps.data.statusTomador != 'A'">
              <div class="card-body">
                <div class="col-md-12 mb-2">
                  <label for="observacaoTomador">Observação: *</label>
                  <br>
                  <textarea v-model="observacaoTomador" style=" width: 450px;height: 100px; border-radius: 5px;"
                    :disabled="slotProps.data.statusTomador === 'N' || slotProps.data.statusTomador === 'A'" type="text"
                    rows="5" />
                </div>
              </div>
              <hr />
              <Button label="Aceitar Cancelamento" style="margin-right: .5em" icon="pi pi-check"
                @click="cancelarNotaFiscal(slotProps.data)"
                :disabled="slotProps.data.statusTomador === 'N' || slotProps.data.statusTomador === 'A'" />
              <Button class="p-button-danger" label="Negar Cancelamento" icon="pi pi-times"
                @click="negarCancelamentoNota(slotProps.data)"
                :disabled="slotProps.data.statusTomador === 'N' || slotProps.data.statusTomador === 'A'" />
            </div>
            <div v-if="slotProps.data.statusTomador === 'N' || slotProps.data.statusTomador === 'A'">{{slotProps.data.observacaoTomador}}</div>
          </template>
        </Column>
        <Column field="notaFiscal.numero" header="Número Nota" bodyStyle="text-align:center"></Column>
        <Column headerStyle="width: 40%" field="observacaoNota" header="Solicitação de Cancelamento"
          bodyStyle="text-align:left"></Column>
        <Column field="statusTomadorFormatado"
          :header="currentUser && currentUser.usuario && currentUser.usuario.idUsuario === '6866f81d-967e-4808-bb27-0dcf85594275' ? 'Status Tomador' : 'Status'"
          bodyStyle="text-align:left"></Column>
      </DataTable>
      <hr />
      <template #footer></template>
      <Button label="Fechar" icon="pi pi-times" @click="ocultarTelaDeferimento()" class="p-button-danger" />
    </Dialog>
  </div>
</template>
<script>
import { maska } from 'maska'
import DapsService from "../services/nfse/daps.service";
import ReportService from "../services/report.service";
import money from "../conf/config.money";
import LoginService from "../services/acesso/login.service";
import NfsPessoaService from "../services/nfse/pessoa.service";
import ConsultaDeclaracoesNotaFiscal from '../components/emissaoNfse/ConsultaDeclaracoesNotaFiscal';
import CancelarNotaFiscal from "../components/emissaoNfse/CancelarNotaFiscal";
import EnviarEmailDaps from "../components/emissaoNfse/EnviarEmailDaps";
import AceiteCancelamentoService from '../services/nfse/aceite.cancelamento.service';
import NotaFiscalService from "@/services/nfse/notafiscal.service";
import CustomCalendar from "../components/global/CustomCalendar.vue";
import ExportarNfseMaiorPeriodo from "@/components/emissaoNfse/ExportarNfseMaiorPeriodo.vue";

export default {
  components: { ConsultaDeclaracoesNotaFiscal, CancelarNotaFiscal, EnviarEmailDaps, CustomCalendar, ExportarNfseMaiorPeriodo},
  props: {
    notaTomador: Boolean
  },
  directives: { maska },
  name: "ConsultaDaps",
  data() {
    return {
      money: money,
      inativo: false,
      display: false,
      loading: false,
      filtro: "",
      filtroNumero: "",
      filtroSituacao: "",
      filtroSituacoes: [
        { name: "Todos", key: "T" },
        { name: "Ativa", key: "A" },
        { name: "Cancelada", key: "C" },
        { name: "Substituída", key: "S" },
        { name: "Retido Na Fonte", key: "R" },
        { name: "Recusada", key: "E" }
      ],
      erros: [],
      dapsList: [],
      dapsId: null,
      currentUser: null,
      observacaoClienteNfse: false,
      filteredPessoas: null,
      selectedPessoa: null,
      dataFatoGeradorIni: null,
      dataFatoGeradorFim: null,
      selectedTipoDaps: null,
      selectedIdDaps: null,
      anexosDaps: [],
      displayAnexos: false,
      exibirConsultaDeclaracao: true,
      exibirMotivoRecusa: false,
      showMotivoRecusa: false,
      motivoRecusaList: [],
      dapsSelecionada: null,
      filtroPesquisarIntermediario: false,
      deferimentos: [],
      notaFiscal: [],
      showDeferimento: false,
      tiposDaps: [
        { name: "Todos", key: "A" },
        { name: (this.notaTomador ? "Serviços Prestados" : "DAPS Prestados"), key: "P" },
        { name: (this.notaTomador ? "Serviços Tomados" : "DAPS Tomados"), key: "T" },
        { name: "Notas Fiscais Eletrônicas Tomadas", key: "E" }
      ],
      menuImpressao: [
        {
          label: (this.notaTomador ? 'Relação de Notas Tomador' : 'Relação de DAPS'),
          icon: 'pi pi-print',
          disabled: this.loading,
          command: () => {
            this.imprimirPdf();
          }
        },
        {
          label: 'Livro Fiscal Serviços Tomados',
          icon: 'pi pi-print',
          disabled: this.loading,
          command: () => {
            this.imprimirLivroFiscalTomados();
          }
        }
      ],
      statusAceite: true,
      observacaoTomador: null
    };
  },

  mounted() {
    document.getElementById("filtroNumero").focus();
  },

  created() {
    this.currentUser = LoginService.currentUserValue;
    this.dataFatoGeradorIni = new Date();
    this.dataFatoGeradorIni.setDate(this.dataFatoGeradorIni.getDate() - 60);
    this.dataFatoGeradorFim = new Date();
    if (this.currentUser.configuracao && this.currentUser.configuracao.idBolModeloFechamento === 'E') {
      this.exibirConsultaDeclaracao = false;
    }
    this.inativo = (this.currentUser && this.currentUser.contribuinte ? !this.currentUser.contribuinte.ativo : false);
    this.selectedTipoDaps = this.tiposDaps[0];
    this.selectedPessoa = "";
    this.observacaoClienteNfse = this.currentUser.configuracao.idBolObservacaoNfse === "S";
    this.pesquisar();
  },

  methods: {
    handleDateInput(event, field) {
      if (typeof event === 'string' && event.match(/^\d{2}\/\d{2}\/\d{4}$/)) {
        const [day, month, year] = event.split('/');
        const date = new Date(year, month - 1, day);
        if (!isNaN(date.getTime())) {
          this[field] = date;
        }
      }
    },
    pesquisar() {
      this.erros = []
      this.processando(true);

      if (!this.dataFatoGeradorIni) {
        this.$root.$emit("alert:warn", "Data Inicial Obrigatório para consulta!");
        return;
      }
      if (!this.dataFatoGeradorFim) {
        this.$root.$emit("alert:warn", "Data Final Obrigatório para consulta!");
        return;
      }
      /*if (this.selectedPessoa && this.selectedPessoa.documento){
        this.filtro = this.selectedPessoa.documento;
      } else {
        this.filtro = "";
      }*/

      DapsService.listAllFiltroPesquisar(
        this.filtro,
        this.filtroNumero,
        this.dataFatoGeradorIni,
        this.dataFatoGeradorFim,
        this.selectedTipoDaps.key,
        (this.filtroSituacao ? this.filtroSituacao.key : "T"),
        this.filtroPesquisarIntermediario
      )
        .then(response => {
          this.dapsList = response;
          console.log(this.dapsList);
        })
        .then(() => {
          this.processando(false);
        });
    },

    consultaDeclaracoesDaps(tipo, id) {
      if (tipo && id) {
        this.$root.$emit("daps:consultaDeclaracoes", tipo, id);
      }
    },

    consultaMotivoRecusa(daps) {
      this.showMotivoRecusa = true;
      this.dapsSelecionada = daps;
      DapsService.listMotivoRecusaDaps(
        daps
      ).then(
        response => {
          this.motivoRecusaList = response.data;
          console.log(response);
          console.log(this.motivoRecusaList);
        },
        error => {
          let errorMessage = "Houve um problema ao listar as Declarações!";
          if (error.response) {
            errorMessage = error.response.data;
          }
          this.$toast.add({
            severity: "error",
            summary: errorMessage
          });
        });
    },

    consultaDeferimento() {
      AceiteCancelamentoService.findNotasAceite(
        this.documentoTomador,
        this.idNota
      ).then(
        aceite => {
          this.deferimentos = aceite.data;
          this.deferimentos.forEach(deferimento => {
            const nota = deferimento.notaFiscal;
            this.notaFiscal = nota;
          });

        },
        error => {
          let errorMessage = "Houve um problema ao listar a nota para deferimento!";
          if (error.response) {
            errorMessage = error.response.data;
          }
          this.$toast.add({
            severity: "error",
            summary: errorMessage
          });
        }
      );
    },

    exibirTelaDeferimento(idNota, documento) {
      this.observacaoTomador = null;
      this.showDeferimento = true;
      this.idNota = idNota;
      this.documentoTomador = documento;
      this.consultaDeferimento();
    },

    ocultarTelaDeferimento() {
      this.showDeferimento = false;
    },

    exibirCampoNfsa(tipo, situacao) {
      if (tipo === "NA") {
        if (situacao.includes("Paga")) {
          return true;
        } else {
          return false;
        }
      } else {
        return true;
      }
    },

    cancelarNotaFiscal(deferimentoNota) {
      var msg = null;
      if (!this.observacaoTomador) {
        msg = "O campo Observação é de preenchimento obrigatório!";
      }
      if (!msg) {

        if (deferimentoNota) {
          NotaFiscalService.aceiteCancelamento(
            deferimentoNota.notaFiscal.id,
            deferimentoNota.id,
            deferimentoNota.observacaoNota,
            this.observacaoTomador
          )
            .then(
              (data) => {
                console.log(data);
                this.$root.$emit("alert:success", "Análise realizada com Sucesso!");
                this.showDeferimento = false;
                this.pesquisar();
              },
              (error) => {
                this.$parent.erros.push(...error.response.data);
                console.log(error.response);
              }
            )
        }
      } else {
        this.$root.$emit("alert:warn", msg);
      }
    },

    negarCancelamentoNota(deferimentoNota) {
      var msg = null;
      if (!this.observacaoTomador) {
        msg = "O campo Observação é de preenchimento obrigatório!";
      }
      if (!msg) {
        if (deferimentoNota) {
          NotaFiscalService.negarCancelamento(
            deferimentoNota.notaFiscal.id,
            deferimentoNota.id,
            this.observacaoTomador
          )
            .then(
              (data) => {
                console.log(data);
                this.$toast.add({
                  severity: "success",
                  summary: "Cancelamento da Nota Fiscal Foi Negado!",
                  life: 2500
                });
                this.consultaDeferimento();
              },
              (error) => {
                let errorMessage = "Houve um erro negar o cancelamento da Nota Fiscal!";
                if (error.response) {
                  errorMessage = error.response.data;
                }
                this.$toast.add({
                  severity: "error",
                  summary: errorMessage,
                  life: 3000
                });
              }
            )
        }
      } else {
        this.$root.$emit("alert:warn", msg);
      }
    },

    detailDaps(id) {
      this.$router.push({ name: "emissaoDaps", params: { idDaps: id } });
    },

    searchPessoa(event) {
      setTimeout(async () => {
        this.filteredPessoas = await NfsPessoaService.findAllByConttribuinteFiltroDaps(
          event.query,
          "",
          ""
        );
      }, 250);
    },

    async verificarFiltroPorInscricao() {
      try {
        const response = await DapsService.verificarFiltroPorInscricao(
          this.currentUser.usuario.idCliente,
          LoginService.currentUserValue.contribuinte.idNfsPessoa
        );

        return response && response.data === "OK";
      } catch (error) {
        console.error("Erro ao verificar filtro por inscrição:", error);
        return false;
      }
    },

    ocultarDialogRecusaDaps() {
      this.showMotivoRecusa = false;
    },

    imprimirPdf() {
      this.imprimirConsultaDAPS('pdf');
    },

    imprimirExcel() {
      this.imprimirConsultaDAPS('xls');
    },

    async imprimirConsultaDAPS(tipo) {
      let filtroPorInscricao = await this.verificarFiltroPorInscricao();
      var msg = null;
      if (!this.currentUser.contribuinte.documento) {
        msg = "É necessário informar o contribuinte!";
      }
      else if (!this.dataFatoGeradorIni) {
        msg = "É necessário informar a data Inicial!";
      }
      else if (!this.dataFatoGeradorFim) {
        msg = "É necessário informar a data Final!";
      }
      /*if (this.selectedPessoa && this.selectedPessoa.documento){
        this.filtro = this.selectedPessoa.documento;
      } else {
        this.filtro = null;
      }*/
      if (!msg) {
        let contr = '(' + this.currentUser.contribuinte.documento + ') ' + this.currentUser.contribuinte.nome + ' - ' + this.currentUser.contribuinte.inscMunic;
        this.processando(true);
        ReportService.imprimir((tipo == 'pdf' ? "ConsultaDaps" : "ConsultaDapsXls"), [
          {
            param: "ID_CLIENTE",
            string: this.currentUser.usuario.idCliente
          },
          {
            param: "WHERE_TOMADOR",
            string: (this.currentUser.configuracao.idBolNovoFiltroDocumento === 'S' ? " nota.documento_tomador = '" + this.currentUser.contribuinte.documento + "'" : " nfs_pessoa_tomador.documento = '" + this.currentUser.contribuinte.documento + "'")
          },
          {
            param: "WHERE_PRESTADOR",
            string: (this.currentUser.configuracao.idBolNovoFiltroDocumento === 'S' ? " nota.documento_prestador = '" + this.currentUser.contribuinte.documento + "'" : " nfs_pessoa_prestador.documento = '" + this.currentUser.contribuinte.documento + "'")
          },
          {
            param: "INSC_MUNIC",
            string: (filtroPorInscricao ? this.currentUser.contribuinte.inscMunic : null)
          },
          {
            param: "CONTRIBUINTE",
            string: contr
          },
          {
            param: "FILTRO",
            string: this.filtro
          },
          {
            param: "TIPO_DAPS",
            string: this.selectedTipoDaps.key
          },
          {
            param: "NUMERO",
            string: this.filtroNumero
          },
          {
            param: "DATA_INICIAL",
            date: this.dataFatoGeradorIni
          },
          {
            param: "DATA_FINAL",
            date: this.dataFatoGeradorFim
          },
          {
            param: "NOTA_TOMADOR",
            string: this.notaTomador ? 'S' : 'N'
          },
          {
            param: "P_SITUACAO",
            string: (this.filtroSituacao && this.filtroSituacao.key != 'T' ? this.filtroSituacao.key : 'T'),
          },
        ], tipo)
          .then(
            () => { },
            error => {
              this.$root.$emit("alert:warn", "Erro ao Imprimir!");
              console.log(error);
            }
          )
          .then(() => {
            this.processando(false);
          });
      }
      else {
        this.$root.$emit("alert:warn", msg);
      }
    },

    async imprimirRelacaoNfse() {
      this.processando(true);
      let filtroPorInscricao = await this.verificarFiltroPorInscricao();
      let contr = '(' + this.currentUser.contribuinte.documento + ') ' + this.currentUser.contribuinte.nome + ' - ' + this.currentUser.contribuinte.inscMunic;
      ReportService.imprimir("ConsultaNfse", [
        {
          param: "DATA_INICIAL",
          date: this.dataFatoGeradorIni
        },
        {
          param: "DATA_FINAL",
          date: this.dataFatoGeradorFim
        },
        {
          param: "WHERE_TOMADOR",
          string: (this.currentUser.configuracao.idBolNovoFiltroDocumento === 'S' ? " nota.documento_tomador = '" + this.currentUser.contribuinte.documento + "'" : " nfs_pessoa_tomador.documento = '" + this.currentUser.contribuinte.documento + "'")
        },
        {
          param: "P_SITUACAO",
          string: (this.filtroSituacao ? this.filtroSituacao.key : null)
        },
        {
          param: "ID_CLIENTE",
          string: this.currentUser.usuario.idCliente
        },
        {
          param: "INSC_MUNIC",
          string: (filtroPorInscricao ? this.currentUser.contribuinte.inscMunic : null)
        },
        {
          param: "CONTRIBUINTE",
          string: contr
        },
        {
          param: "FILTRO",
          string: this.filtro
        }
      ])
        .then(
          () => { },
          (error) => {
            if (error.response && error.response.data instanceof Blob) {
              const reader = new FileReader();
              reader.onload = () => {
                try {
                  const result = JSON.parse(reader.result);
                  this.$root.$emit("alert:warn", result.message || result);
                } catch (e) {
                  this.$toast.add({
                    group: "cb",
                    severity: "warn",
                    summary: "Aviso",
                    detail: reader.result,
                    life: 15000,
                  });
                }
              };
              reader.readAsText(error.response.data);
            } else if (error.response && error.response.data) {
              this.$root.$emit("alert:warn", error.response.data);
            } else {
              this.$root.$emit("alert:warn", "Erro inesperado na impressão.");
            }
          }
        )
        .then(() => {
          this.processando(false);
        });
    },

    async imprimirLivroFiscalTomados() {
      let filtroPorInscricao = await this.verificarFiltroPorInscricao();
      var msg = null;
      if (!this.currentUser.contribuinte.documento) {
        msg = "É necessário informar o contribuinte!";
      }
      else if (!this.dataFatoGeradorIni) {
        msg = "É necessário informar a data Inicial!";
      }
      else if (!this.dataFatoGeradorFim) {
        msg = "É necessário informar a data Final!";
      }

      if (!msg) {
        this.processando(true);
        ReportService.imprimir("LivroFiscalServicosTomados", [
          {
            param: "ID_CLIENTE",
            string: this.currentUser.usuario.idCliente
          },
          {
            param: "WHERE_TOMADOR",
            string: (this.currentUser.configuracao.idBolNovoFiltroDocumento === 'S' ? " nota.documento_tomador = '" + this.currentUser.contribuinte.documento + "'" : " nfs_pessoa_tomador.documento = '" + this.currentUser.contribuinte.documento + "'")
          },
          {
            param: "INSC_MUNIC",
            string: (filtroPorInscricao ? this.currentUser.contribuinte.inscMunic : null)
          },
          {
            param: "DATA_INICIAL",
            date: this.dataFatoGeradorIni
          },
          {
            param: "DATA_FINAL",
            date: this.dataFatoGeradorFim
          },
          {
            param: "NOME_PRESTADOR",
            string: this.currentUser.contribuinte.nome
          },
          {
            param: "NOME_EMPRESA",
            string: this.currentUser.usuario.nomeCliente
          },
          {
            param: "P_SITUACAO",
            string: (this.filtroSituacao && this.filtroSituacao.key != 'T' ? this.filtroSituacao.key : null),
          }
        ])
          .then(
            () => { },
            error => {
              this.$root.$emit("alert:warn", "Erro ao Imprimir!");
              console.log(error);
            }
          )
          .then(() => {
            this.processando(false);
          });
      }
      else {
        this.$root.$emit("alert:warn", msg);
      }
    },

    visualizarDanfse(idNota) {
      this.processando(true);

      NotaFiscalService.downloadDanfseHtml(idNota)
        .then(response => {
            const html = response.data;
            ReportService.openHtmlFromBytes(html);
        }).catch(error => {
            this.$root.$emit("alert:warn", "Erro ao efetuar o download da DANFSE!");
            console.error('Erro ao efetuar o download da DANFSE:', error);
        }).then(() => {
            this.processando(false);
        });
    },

    visualizar(tipo, id) {
      this.processando(true);

      let nomeRel = (tipo === 'D' ? (this.notaTomador ? 'NotaFiscalTomador' : 'NotaFiscalAuxiliar') : (this.observacaoClienteNfse ? "NotaFiscalEletronicaObs" : "NotaFiscalEletronica"));
      let where = tipo === 'D' ? " and nota.id = '" + id + "'" : " and nota_fiscal.id = '" + id + "'";
      ReportService.imprimir(nomeRel, [
        {
          param: "where",
          string: where
        }
      ])
        .then(
          () => { },
          error => {
            this.$root.$emit("alert:warn", "Erro ao exibir a visualização!");
            console.log(error);
          }
        )
        .then(() => {
          this.processando(false);
        });
    },

    download(tipo, id) {
      this.processando(true);

      let nomeRel = (tipo === 'D' ? (this.notaTomador ? 'NotaFiscalTomador' : 'NotaFiscalAuxiliar') : (this.observacaoClienteNfse ? "NotaFiscalEletronicaObs" : "NotaFiscalEletronica"));
      let where = tipo === 'D' ? " and nota.id = '" + id + "'" : " and nota_fiscal.id = '" + id + "'";

      ReportService.download(nomeRel, [
        {
          param: "where",
          string: where
        }
      ])
        .then(
          () => { },
          error => {
            this.$root.$emit("alert:warn", "Erro ao efetuar o download!");
            console.log(error);
          }
        )
        .then(() => {
          this.processando(false);
        });
    },

    downloadXml(nfseId) {
      this.processando(true);

      ReportService.downloadXml(nfseId)
        .then(
          (data) => {
            console.log(data);
          },
          (error) => {
            this.$root.$emit("alert:warn", "Erro ao efetuar o download!");
            console.log(error);
          }
        )
        .then(() => {
          this.processando(false);
        });
    },

    cancelarDaps(idDaps) {
      this.processando(true);
      console.log(idDaps);
      this.erros = [];
      DapsService.cancelar(idDaps)
        .then(
          data => {
            console.log(data);
            this.$toast.add({
              severity: "success",
              summary: "Sucesso",
              detail: "O DAPS foi Cancelado!",
              life: 4000
            });
            this.pesquisar();
          },
          error => {
            this.erros.push(...error.response.data);
            console.log(error.response);
          }
        )
        .then(() => {
          this.processando(false);
        });
    },

    detail(dapsId) {
      this.$router.push({ name: "emissaoDaps", params: { id: dapsId } });
    },
    visualizarAnexo(id) {
      this.processando(true);
      this.anexosDaps = [];
      DapsService.carregarAnexosDaps(
        id
      ).then((response) => {
        this.anexosDaps = response.data;
        this.displayAnexos = true;
      }).then(() => {
        this.processando(false);
      });
    },
    downloadArquivo(id, type, nome) {
      this.processando(true);
      DapsService.downloadAnexo(
        id, type, nome
      ).then(
        (data) => {
          console.log(data);
        },
        (error) => {
          this.$root.$emit("alert:warn", "Erro ao efetuar o download!");
          console.log(error);
        }
      )
        .then(() => {
          this.processando(false);
        });
    },

    processando(show) {
      if (show) {
        this.loading = true;
        this.$root.$emit("loading:show");
      } else {
        this.loading = false;
        this.$root.$emit("loading:hide");
      }
    },

    exportarMaiorPeriodo() {
      this.$root.$emit("notaFiscal:exportarMaiorPeriodo");
    },

    downloadListagemXml(nacional = false) {
      var msg = null;
      if (!this.currentUser.contribuinte.idContribuinte) {
        msg = "É necessário informar o contribuinte!";
      } else if (!this.dataFatoGeradorIni) {
        msg = "É necessário informar a data Inicial!";
      } else if (!this.dataFatoGeradorFim) {
        msg = "É necessário informar a data Final!";
      } else if (!this.filtroSituacao && !this.filtroSituacao.key) {
        msg = "É necessário informar uma Situação!"
      }

      if (!msg) {
        this.processando(true);
        ReportService.downloadListXmlTomador(
          this.currentUser.contribuinte.idContribuinte,
          this.dataFatoGeradorIni,
          this.dataFatoGeradorFim,
          (this.filtroSituacao && this.filtroSituacao.key != 'T' ? this.filtroSituacao.key : null),
          this.$root,
          nacional
        )
          .then(
            (data) => {
              console.log(data);
            },
            (error) => {
              console.log(error);
            }
          )
          .then(() => {
            this.processando(false);
          });
      } else {
        this.$root.$emit("alert:warn", msg);
      }
    },
    exportCSV() {
      this.$refs.dt.exportCSV();
    },
    enviarEmail(id) {
      if (id) {
        this.$root.$emit("daps:enviarEmail", id);
      }
    },
  },

  computed: {
    nomeFiltro: {
      get() {
        return (
          "CPF/CNPJ/Nome" +
          (this.selectedTipoDaps.key == "A" ? "" : (this.selectedTipoDaps.key == "T" ? " Prestador" : " Tomador"))
        );
      }
    },

    exibirFiltroIntermediario: {
      get() {
        return (this.currentUser.configuracao.idBolIntermediario === "S");
      }
    },

    exibirAnaliseCancelamento: {
      get() {
        return (this.currentUser.configuracao.nfCancelamentoCienciaTomador && this.currentUser.configuracao.nfCancelamentoCienciaTomador === 'S') || false;
      }
    }
  }
};
</script>
<style scoped>
.mensagem-cancelamento {
  color: red;
  font-weight: bold;
  white-space: pre-wrap;
}
</style>
<style src="../assets/css/consultaDaps.css"></style>
